<script>
    // Politica de privacidad.
    //
    // Google Play EXIGE una URL publica con esta politica para poder publicar la
    // app, y la revisa desde afuera: por eso esta pagina NO usa Navbar2 ni nada
    // que dependa de la sesion. Tiene que abrir sin login.
    //
    // El contenido describe lo que la app REALMENTE hace hoy (relevado sobre el
    // modelo: User, Establishment y las entidades productivas). Si se agregan
    // datos nuevos —o un proveedor nuevo— hay que actualizar esta pagina, porque
    // la declaracion de Data Safety de Play tiene que coincidir con esto.
    //
    // Los datos del responsable (nombre, domicilio, CUIT y correo de contacto)
    // los aporto Pilar el 16/08. Si cambian, hay que tocarlos en los dos lugares
    // donde aparece el correo: el bloque del responsable y la seccion Contacto.
    //
    // 30/08: alineacion con la ficha de Play (ver ../docs/play-ficha-tienda.md §0).
    // La ficha muestra como desarrollador a otra persona que la que figura aca como
    // responsable, y Google compara los dos documentos: por eso el bloque del
    // responsable aclara ahora bajo que cuenta se distribuye la app. Se sumo ademas
    // OpenStreetMap a los terceros (lo usa MapaPicker.svelte para los mosaicos del
    // mapa). El correo canonico es crecientefertil1@gmail.com, y el "correo de
    // ayuda" de Play Console tiene que decir ese mismo.
    const actualizado = "30 de agosto de 2026";
</script>

<svelte:head>
    <title>Política de privacidad · Creciente Fértil</title>
    <meta
        name="description"
        content="Cómo Creciente Fértil recolecta, usa y protege los datos personales de quienes usan la aplicación."
    />
</svelte:head>

<div class="min-h-screen bg-cf-bg py-10 px-4">
    <div class="mx-auto max-w-3xl bg-cf-surface rounded-xl shadow-lg p-6 sm:p-10">
        <h1 class="text-3xl font-bold text-cf-primary mb-1">Política de privacidad</h1>
        <p class="text-sm text-cf-text-sub mb-8">
            Última actualización: {actualizado}
        </p>

        <div class="space-y-8 text-cf-text leading-relaxed">
            <section class="space-y-2">
                <p>
                    Esta política explica qué datos personales recolecta la aplicación
                    <strong>Creciente Fértil</strong>, con qué finalidad los usa y qué derechos
                    tenés sobre ellos. Se aplica tanto a la aplicación móvil como a la versión web.
                </p>
                <p class="rounded-lg bg-cf-surface-alt p-3 text-sm">
                    <strong>Responsable del tratamiento:</strong>
                    Facundo Lorenzo Hecker, CUIT 20-37086808-6, con domicilio en Calle 9
                    N° 165, Embajador Martini, provincia de La Pampa, Argentina.
                    <br />
                    <strong>Contacto:</strong> crecientefertil1@gmail.com
                    <br />
                    La aplicación se distribuye en Google Play a través de la cuenta de
                    desarrollador <strong>Equipo Fertil</strong>. El responsable del
                    tratamiento de los datos es quien figura arriba.
                </p>
            </section>

            <section class="space-y-3">
                <h2 class="text-xl font-semibold text-cf-primary">Qué datos recolectamos</h2>

                <h3 class="font-semibold">De tu cuenta</h3>
                <ul class="list-disc pl-6 space-y-1">
                    <li>Nombre y apellido.</li>
                    <li>Correo electrónico, que además identifica tu cuenta.</li>
                    <li>
                        Contraseña, que se guarda cifrada: nadie del equipo puede leerla ni
                        recuperarla.
                    </li>
                    <li>Teléfono, sólo si elegís cargarlo, para avisos sobre tu suscripción.</li>
                </ul>

                <h3 class="font-semibold">De tu establecimiento</h3>
                <ul class="list-disc pl-6 space-y-1">
                    <li>Nombre, dirección, localidad y provincia.</li>
                    <li>Código RENSPA.</li>
                    <li>Teléfono, correo y nombre del titular.</li>
                    <li>
                        Ubicación geográfica del campo (latitud y longitud), sólo si la cargás.
                        <strong>La aplicación no accede al GPS de tu teléfono</strong> ni sigue tu
                        ubicación.
                    </li>
                </ul>

                <h3 class="font-semibold">De tu actividad productiva</h3>
                <ul class="list-disc pl-6 space-y-1">
                    <li>
                        Animales, lotes, rodeos, pesajes, tratamientos, servicios, tactos,
                        nacimientos y movimientos que cargás.
                    </li>
                </ul>
                <p class="text-sm text-cf-text-sub">
                    Son datos de tu explotación, no datos personales, pero los protegemos igual:
                    sólo vos y las personas que invitás a tu establecimiento pueden verlos.
                </p>

                <h3 class="font-semibold">Técnicos</h3>
                <ul class="list-disc pl-6 space-y-1">
                    <li>
                        Un identificador del dispositivo, que sirve para mantener la sesión abierta
                        y para que puedas cerrarla en un equipo puntual.
                    </li>
                    <li>Fecha de validación de tu correo.</li>
                </ul>
            </section>

            <section class="space-y-2">
                <h2 class="text-xl font-semibold text-cf-primary">Para qué los usamos</h2>
                <ul class="list-disc pl-6 space-y-1">
                    <li>Para darte acceso a la aplicación y mantener tu sesión.</li>
                    <li>Para guardar y mostrarte la información de tu establecimiento.</li>
                    <li>
                        Para administrar tu suscripción y avisarte sobre su estado, por ejemplo
                        cuando estás cerca del límite de tu plan.
                    </li>
                    <li>Para responderte si nos escribís.</li>
                </ul>
                <p>
                    <strong>No vendemos tus datos</strong>, no los cedemos a terceros con fines
                    comerciales y no los usamos para publicidad.
                </p>
            </section>

            <section class="space-y-2">
                <h2 class="text-xl font-semibold text-cf-primary">Servicios de terceros</h2>
                <p>Sólo compartimos datos con proveedores necesarios para que la app funcione:</p>
                <ul class="list-disc pl-6 space-y-1">
                    <li>
                        <strong>Ingreso con Google.</strong> Si elegís entrar con tu cuenta de
                        Google, recibimos únicamente tu correo y los datos básicos de tu perfil.
                        Nunca recibimos tu contraseña de Google.
                    </li>
                    <li>
                        <strong>Mercado Pago.</strong> Procesa los pagos de las suscripciones. Los
                        datos de tu tarjeta los maneja Mercado Pago directamente:
                        <strong>nosotros no los recibimos ni los guardamos.</strong>
                    </li>
                    <li>
                        <strong>Correo electrónico.</strong> Usamos un servicio de envío para los
                        avisos de la cuenta y la suscripción.
                    </li>
                    <li>
                        <strong>OpenStreetMap.</strong> Si abrís el mapa para marcar dónde
                        queda tu campo, las imágenes del mapa las provee OpenStreetMap, que
                        por eso ve la dirección IP de tu conexión. No le enviamos ningún dato
                        tuyo ni de tu establecimiento.
                    </li>
                </ul>
            </section>

            <section class="space-y-2">
                <h2 class="text-xl font-semibold text-cf-primary">Datos guardados en tu teléfono</h2>
                <p>
                    La aplicación está pensada para funcionar <strong>sin conexión</strong>, porque
                    en el campo muchas veces no hay señal. Para eso guarda una copia de tu
                    información en el propio dispositivo, y la sincroniza con el servidor cuando
                    volvés a tener internet.
                </p>
                <p>
                    Esa copia vive solamente en tu teléfono. Si desinstalás la aplicación o cerrás
                    sesión, se borra.
                </p>
            </section>

            <section class="space-y-2">
                <h2 class="text-xl font-semibold text-cf-primary">Cuánto tiempo los conservamos</h2>
                <p>
                    Conservamos tus datos mientras tu cuenta esté activa. Si la eliminás, se
                    borran, y con ellos los establecimientos en los que seas la única persona, con
                    toda su información. Los establecimientos que compartís con colaboradores
                    siguen siendo de ellos: lo que se borra es tu acceso. Se conserva el historial
                    de pagos, sin quedar asociado a vos, por el plazo que exige la normativa
                    contable. Está todo detallado en
                    <a class="underline" href="/eliminar-cuenta">cómo eliminar tu cuenta</a>.
                </p>
            </section>

            <section class="space-y-2">
                <h2 class="text-xl font-semibold text-cf-primary">Tus derechos</h2>
                <p>
                    Podés pedir acceder a tus datos, corregirlos, actualizarlos o eliminarlos.
                    Escribinos al correo de contacto y te respondemos.
                </p>
                <p>
                    <strong>Podés eliminar tu cuenta vos misma o vos mismo</strong> desde la
                    aplicación, en Configuración de la cuenta, sin necesidad de pedírnoslo:
                    <a class="underline" href="/eliminar-cuenta">acá están los pasos y qué se
                    borra</a>.
                </p>
                <p class="text-sm text-cf-text-sub">
                    En Argentina, el tratamiento de datos personales está regulado por la Ley 25.326.
                    La Agencia de Acceso a la Información Pública es el organismo de control y
                    atiende las denuncias de quien considere afectados sus derechos.
                </p>
            </section>

            <section class="space-y-2">
                <h2 class="text-xl font-semibold text-cf-primary">Seguridad</h2>
                <p>
                    Las comunicaciones entre la aplicación y el servidor viajan cifradas. Las
                    contraseñas se guardan cifradas y de forma irreversible. El acceso a la
                    información de cada establecimiento está limitado a su titular y a las personas
                    que él o ella haya invitado, con los permisos que les haya asignado.
                </p>
            </section>

            <section class="space-y-2">
                <h2 class="text-xl font-semibold text-cf-primary">Menores de edad</h2>
                <p>
                    La aplicación está dirigida a personas que gestionan una explotación ganadera y
                    no está pensada para menores de 18 años.
                </p>
            </section>

            <section class="space-y-2">
                <h2 class="text-xl font-semibold text-cf-primary">Cambios en esta política</h2>
                <p>
                    Si cambiamos algo importante, actualizamos la fecha del encabezado y te avisamos
                    dentro de la aplicación o por correo.
                </p>
            </section>

            <section class="space-y-2">
                <h2 class="text-xl font-semibold text-cf-primary">Contacto</h2>
                <p>
                    Por cualquier consulta sobre esta política o sobre tus datos, escribinos a
                    crecientefertil1@gmail.com.
                </p>
            </section>
        </div>
    </div>
</div>
